export const DEFAULT_SCAN_COOLDOWN_MS = 8_000;
export const CAPTURE_SCAN_COOLDOWN_POLICY_KEY = "capture.scan_cooldown_seconds";

export interface ScanCooldownPolicyRow {
  key?: unknown;
  effective_value?: unknown;
  effectiveValue?: unknown;
  source?: unknown;
}

export interface ScanCooldownState {
  value: string;
  acceptedAtMs: number;
}

export interface ScanCooldownInput {
  rawValue: string;
  nowMs: number;
  previous: ScanCooldownState | null;
  cooldownMs?: number;
}

export interface ScanCooldownResult {
  accepted: boolean;
  nextState: ScanCooldownState | null;
  remainingMs: number;
}

export function evaluateScanCooldown(input: ScanCooldownInput): ScanCooldownResult {
  const value = input.rawValue.trim();
  const cooldownMs = input.cooldownMs ?? DEFAULT_SCAN_COOLDOWN_MS;

  if (!input.previous || input.previous.value !== value) {
    return {
      accepted: true,
      nextState: { acceptedAtMs: input.nowMs, value },
      remainingMs: 0,
    };
  }

  const elapsedMs = input.nowMs - input.previous.acceptedAtMs;
  if (elapsedMs >= cooldownMs) {
    return {
      accepted: true,
      nextState: { acceptedAtMs: input.nowMs, value },
      remainingMs: 0,
    };
  }

  return {
    accepted: false,
    nextState: input.previous,
    remainingMs: Math.max(0, cooldownMs - elapsedMs),
  };
}

export function resolveScanCooldownMsFromPolicy(rows: readonly ScanCooldownPolicyRow[] | null | undefined): number {
  const row = rows?.find((candidate) => candidate.key === CAPTURE_SCAN_COOLDOWN_POLICY_KEY);
  const seconds = row?.effective_value ?? row?.effectiveValue;

  if (typeof seconds !== "number" || !Number.isFinite(seconds) || seconds < 0) {
    return DEFAULT_SCAN_COOLDOWN_MS;
  }

  return Math.round(seconds * 1_000);
}
